import { render, staticRenderFns } from "./ucl-quiz-timer.vue?vue&type=template&id=719ab3d7"
import script from "./ucl-quiz-timer.vue?vue&type=script&setup=true&lang=js"
export * from "./ucl-quiz-timer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ucl-quiz-timer.vue?vue&type=style&index=0&id=719ab3d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports